<div (tunResize)="onResize()" class="animation-container">
  <div
    #animationElement
    [style.padding-bottom.px]="extraPaddingBottom"
    [style.padding-top.px]="extraPaddingTop"
  >
    <ng-template tunPopupContent></ng-template>
  </div>
</div>
